<template>
    <!-- info card start -->
    <div class="card">
        <div class="card-header">
            <h5 class="card-header-text">Offer Letter</h5>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col-md-8">
                    <div class="card b-l-success business-info services m-b-20 " :style="regected ? 'border-left: 1px solid red !important;': ''">
                        <div class="card-header">
                            <div class="service-header">
                                <h5 class="card-header-text">Offer Letter</h5>
                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="table-responsive">
                                        <div v-html="selectedTemplate"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card b-l-success business-info services m-b-20 clickable" @click="setOfferLetter(offer)"
                        :style="selected == 0 ? 'background-color: darkgrey;': ''">
                        <div class="card-header">
                            <div class="service-header">
                                <h5 class="card-header-text">Candidate Decision</h5>

                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="table-responsive">
                                        <p class="" v-if="offer.decision =='0'">
                                            <b>Offer letter</b> Declined <br>
                                            <b>Candidate Reason:</b> {{offer.reasonfordecline}}
                                        </p>
                                        <p class="" v-if="offer.decision =='1'">
                                            <b>Offer letter</b> Accepted</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="service-header text-center mb-4">
                        <h4 class="card-header-text text-center">Candidate Rejected Offers</h4>
                    </div>
                    <div v-for="(offer, index) in regectedOffers" :key="index" @click="setOfferLetterRegected(offer)"
                        class="card b-l-regected business-info services m-b-20 clickable" :style="selected == offer.id ? 'background-color: darkgrey;': ''">
                        <div class="card-header">
                            <div class="service-header">
                                <h5 class="card-header-text">{{offer.jobrole_name}}</h5>
                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="table-responsive">
                                        <p class="">
                                            <b>Offer letter</b> Declined <br>
                                            <b>Candidate Reason:</b> {{offer.reasonfordecline}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css" soped>
    tr td:nth-child(1) {
        font-weight: bold;
    }

    .b-l-regected {
        border-left: 1px solid red !important;
    }

    .selected {
        background-color: darkgrey;
    }

    .text-center {
        text-align: center !important;
    }

    .clickable:hover {
        cursor: pointer;
    }
</style>
<script type="text/javascript">
    export default {
        name: 'ScorecardSummary',
        props: ['joblisting_id'],
        // props: {
        //     joblisting_id: Number,
        // },
        data() {
            return {
                offer: {},
                regectedOffers: [],
                regected: false,
                selected: 0
            }
        },

        computed: {
            selectedTemplate() {
                return this.offer.template;
            }
        },

        methods: {

            init: function () {
                setTimeout(this.getOfferLetter, 7000);
                setTimeout(this.getRegectedOfferLetter, 7000);
            },

            setOfferLetterRegected(offer) {
                this.offer_letter = offer.template,
                    this.regected = true;
                this.selected = offer.id;
            },

            setOfferLetter(offer) {
                this.offer_letter = offer.template,
                    this.regected = false;
                this.selected = 0;
            },

            getOfferLetter: function () {
                console.log(this.joblisting_id);
                var ii = {
                    what: 'GetOfferForApplicant',
                    params: {
                        applicant_id: this.$route.params.id,
                        // joblisting_id: this.$parent.applicant.joblistings.id
                        joblisting_id: this.joblisting_id
                    }

                }
                console.log(ii)
                this.$socket.makeGetRequest(ii)
                    .then((response) => {
                        if (response.type == 'GetOfferForApplicant') {
                            console.log(response.data)
                            this.offer = response.data;
                        }
                    })
                    .catch((e) => {
                        this.offer_letter = e.message
                        console.log(e)
                    })
            },

            getRegectedOfferLetter: function () {
                console.log(this.joblisting_id);
                var ii = {
                    what: 'ListRejectedOfferletter',
                    params: {
                        applicant_id: this.$route.params.id,
                    }

                }
                console.log(ii)
                this.$socket.makeGetRequest(ii)
                    .then((response) => {
                        if (response.type == 'ListRejectedOfferletter') {
                            console.log(response.data)
                            this.regectedOffers = response.data;
                        }
                    })
                    .catch((e) => {
                        // this.offer_letter = e.message
                        console.log(e)
                    })
            },
        },
        mounted() {
            this.init()
        }
    }
</script>